import { render, staticRenderFns } from "./AssistedCreateMaterial.vue?vue&type=template&id=7be88098"
import script from "./AssistedCreateMaterial.vue?vue&type=script&lang=js"
export * from "./AssistedCreateMaterial.vue?vue&type=script&lang=js"
import style0 from "./AssistedCreateMaterial.vue?vue&type=style&index=0&id=7be88098&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports